var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c("div", [
      _c("div", [
        _c("div", { staticClass: "d-flex flex-column feedback-container" }, [
          _c("div", { staticClass: "d-flex flex-column gap-5" }, [
            _c(
              "div",
              {
                staticClass:
                  "font-size-150 d-inline-flex align-items-center gap-10px",
              },
              [
                _c(
                  "svg",
                  {
                    attrs: {
                      xmlns: "http://www.w3.org/2000/svg",
                      width: "24",
                      height: "24",
                      viewBox: "0 0 24 24",
                    },
                  },
                  [
                    _c(
                      "g",
                      { attrs: { fill: "none", "fill-rule": "evenodd" } },
                      [
                        _c("path", {
                          attrs: {
                            d: "M24 0v24H0V0zM12.594 23.258l-.012.002l-.071.035l-.02.004l-.014-.004l-.071-.036c-.01-.003-.019 0-.024.006l-.004.01l-.017.428l.005.02l.01.013l.104.074l.015.004l.012-.004l.104-.074l.012-.016l.004-.017l-.017-.427c-.002-.01-.009-.017-.016-.018m.264-.113l-.014.002l-.184.093l-.01.01l-.003.011l.018.43l.005.012l.008.008l.201.092c.012.004.023 0 .029-.008l.004-.014l-.034-.614c-.003-.012-.01-.02-.02-.022m-.715.002a.023.023 0 0 0-.027.006l-.006.014l-.034.614c0 .012.007.02.017.024l.015-.002l.201-.093l.01-.008l.003-.011l.018-.43l-.003-.012l-.01-.01z",
                          },
                        }),
                        _vm._v(" "),
                        _c("path", {
                          attrs: {
                            fill: "currentColor",
                            d: "m20.255 5.52l.087.298l.089.338l.044.185l.089.4l.085.443l.081.485c.026.169.05.345.074.528l.065.572c.08.791.131 1.7.131 2.731s-.05 1.94-.13 2.731l-.066.572c-.023.183-.048.36-.074.528l-.08.485l-.086.443l-.089.4l-.089.36l-.088.317l-.043.144c-.331 1.087-1.464 1.505-2.394 1.195l-1.18-.393l-.4.933a2 2 0 0 1-2.47 1.11l-5.096-1.7a2 2 0 0 1-1.206-2.684l.269-.628L7 15.055l-1.368.456A2 2 0 0 1 3 13.613V9.388A2 2 0 0 1 5.632 7.49L7 7.946l10.861-3.62c.93-.31 2.063.107 2.394 1.194M9.682 15.948l-.335.78l5.096 1.7l.335-.781zm8.706-9.69L8 9.721v3.558l10.388 3.463l.077-.283l.08-.327l.04-.18l.078-.394a17.8 17.8 0 0 0 .076-.439l.07-.485c.112-.847.191-1.887.191-3.134c0-1.246-.08-2.287-.19-3.134l-.071-.485c-.025-.154-.05-.3-.076-.44l-.079-.393l-.08-.349zM5 9.388v4.225l1-.334V9.721z",
                          },
                        }),
                      ]
                    ),
                  ]
                ),
                _vm._v(
                  "\n            " +
                    _vm._s(_vm._f("trans")("Your input matters!")) +
                    "\n          "
                ),
              ]
            ),
            _vm._v(" "),
            _c("p", [
              _vm._v(
                _vm._s(
                  _vm._f("trans")(
                    "Share your thoughts, suggestions, or experiences using our services."
                  )
                )
              ),
            ]),
            _vm._v(" "),
            _c("p", [
              _vm._v(
                "\n            " +
                  _vm._s(_vm._f("trans")("Your feedback helps us improve.")) +
                  "\n            " +
                  _vm._s(
                    _vm._f("trans")(
                      "Thank you for being a part of our journey!"
                    )
                  ) +
                  "\n          "
              ),
            ]),
          ]),
          _vm._v(" "),
          _vm.currentJob.feedback.submittedFull !== true
            ? _c(
                "div",
                { staticClass: "d-flex flex-column gap-20" },
                [
                  _c("div", { staticClass: "d-flex flex-column gap-10" }, [
                    _c("strong", [
                      _vm._v(_vm._s(_vm._f("trans")("How would you rate us?"))),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "d-flex gap-15" }, [
                      _c(
                        "button",
                        {
                          staticClass: "btn-feedback",
                          class: {
                            disabled:
                              _vm.currentJob.feedback.loading === true ||
                              _vm.currentJob.feedback.submittedFull === true,
                            active: _vm.rating === 5,
                          },
                          on: {
                            click: function ($event) {
                              _vm.rating = 5
                            },
                          },
                        },
                        [
                          _c(
                            "svg",
                            {
                              attrs: {
                                xmlns: "http://www.w3.org/2000/svg",
                                width: "18",
                                height: "18",
                                viewBox: "0 0 18 18",
                                fill: "none",
                              },
                            },
                            [
                              _c(
                                "g",
                                {
                                  attrs: { "clip-path": "url(#clip0_2093_99)" },
                                },
                                [
                                  _c("path", {
                                    attrs: {
                                      d: "M18 9C18 13.9705 13.9705 18 9 18C4.0295 18 0 13.9705 0 9C0 4.0295 4.0295 0 9 0C13.9705 0 18 4.0295 18 9Z",
                                      fill: "#FFCC4D",
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c("path", {
                                    attrs: {
                                      d: "M9.00002 10.9245C7.51702 10.9245 6.53252 10.7515 5.31552 10.515C5.03702 10.462 4.49652 10.515 4.49652 11.334C4.49652 12.9715 6.37802 15.0185 9.00002 15.0185C11.622 15.0185 13.5035 12.9715 13.5035 11.334C13.5035 10.515 12.9625 10.4615 12.6845 10.515C11.4675 10.7515 10.4835 10.9245 9.00002 10.9245Z",
                                      fill: "#664500",
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c("path", {
                                    attrs: {
                                      d: "M8.32502 1.64047C8.16088 1.17411 7.85283 0.771957 7.44531 0.492023C7.03779 0.21209 6.55188 0.0688551 6.05768 0.0829846C5.56348 0.0971142 5.08654 0.267877 4.69568 0.570637C4.30482 0.873397 4.02025 1.2925 3.88302 1.76747C3.57922 1.55488 3.22916 1.41768 2.86181 1.36725C2.49446 1.31683 2.12037 1.35461 1.77052 1.47747C1.18683 1.68364 0.7089 2.11315 0.441779 2.67158C0.174659 3.23001 0.140217 3.87166 0.346023 4.45547C0.407023 4.62747 0.488023 4.78697 0.582023 4.93447C1.55752 6.72547 4.37602 7.98447 6.08252 7.99997C7.40102 6.91647 8.80552 4.16747 8.44152 2.16147C8.42261 1.98395 8.38352 1.80915 8.32502 1.64047ZM9.67502 1.64047C9.88109 1.05669 10.3106 0.578643 10.869 0.311424C11.4274 0.0442048 12.0691 0.00969225 12.653 0.215474C13.0029 0.339179 13.3182 0.544492 13.5729 0.814396C13.8276 1.0843 14.0143 1.41102 14.1175 1.76747C14.4213 1.55488 14.7714 1.41768 15.1387 1.36725C15.5061 1.31683 15.8802 1.35461 16.23 1.47747C16.8138 1.68354 17.2919 2.11301 17.5591 2.67145C17.8263 3.22989 17.8608 3.87159 17.655 4.45547C17.5947 4.62361 17.5153 4.78432 17.4185 4.93447C16.443 6.72547 13.6245 7.98447 11.9175 7.99997C10.599 6.91647 9.19502 4.16747 9.55902 2.16147C9.57702 1.98681 9.61569 1.81314 9.67502 1.64047Z",
                                      fill: "#DD2E44",
                                    },
                                  }),
                                ]
                              ),
                              _vm._v(" "),
                              _c("defs", [
                                _c(
                                  "clipPath",
                                  { attrs: { id: "clip0_2093_99" } },
                                  [
                                    _c("rect", {
                                      attrs: {
                                        width: "18",
                                        height: "18",
                                        fill: "white",
                                      },
                                    }),
                                  ]
                                ),
                              ]),
                            ]
                          ),
                          _vm._v(" "),
                          _c("span", { staticClass: "d-none d-lg-block" }, [
                            _vm._v(_vm._s(_vm._f("trans")("Great"))),
                          ]),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "button",
                        {
                          staticClass: "btn-feedback",
                          class: {
                            disabled:
                              _vm.currentJob.feedback.loading === true ||
                              _vm.currentJob.feedback.submittedFull === true,
                            active: _vm.rating === 4,
                          },
                          on: {
                            click: function ($event) {
                              _vm.rating = 4
                            },
                          },
                        },
                        [
                          _c(
                            "svg",
                            {
                              attrs: {
                                xmlns: "http://www.w3.org/2000/svg",
                                width: "18",
                                height: "18",
                                viewBox: "0 0 18 18",
                                fill: "none",
                              },
                            },
                            [
                              _c(
                                "g",
                                {
                                  attrs: {
                                    "clip-path": "url(#clip0_2095_106)",
                                  },
                                },
                                [
                                  _c("path", {
                                    attrs: {
                                      d: "M9 18C13.9706 18 18 13.9706 18 9C18 4.02944 13.9706 0 9 0C4.02944 0 0 4.02944 0 9C0 13.9706 4.02944 18 9 18Z",
                                      fill: "#FFCC4D",
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c("path", {
                                    attrs: {
                                      d: "M9 10.5C7.1885 10.5 5.9865 10.289 4.5 9.99998C4.1605 9.93448 3.5 9.99998 3.5 11C3.5 13 5.7975 15.5 9 15.5C12.202 15.5 14.5 13 14.5 11C14.5 9.99998 13.8395 9.93398 13.5 9.99998C12.0135 10.289 10.8115 10.5 9 10.5Z",
                                      fill: "#664500",
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c("path", {
                                    attrs: {
                                      d: "M4.5 11C4.5 11 6 11.5 9 11.5C12 11.5 13.5 11 13.5 11C13.5 11 12.5 13 9 13C5.5 13 4.5 11 4.5 11Z",
                                      fill: "white",
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c("path", {
                                    attrs: {
                                      d: "M6 8.5C6.69036 8.5 7.25 7.7165 7.25 6.75C7.25 5.7835 6.69036 5 6 5C5.30964 5 4.75 5.7835 4.75 6.75C4.75 7.7165 5.30964 8.5 6 8.5Z",
                                      fill: "#664500",
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c("path", {
                                    attrs: {
                                      d: "M12 8.5C12.6904 8.5 13.25 7.7165 13.25 6.75C13.25 5.7835 12.6904 5 12 5C11.3096 5 10.75 5.7835 10.75 6.75C10.75 7.7165 11.3096 8.5 12 8.5Z",
                                      fill: "#664500",
                                    },
                                  }),
                                ]
                              ),
                              _vm._v(" "),
                              _c("defs", [
                                _c(
                                  "clipPath",
                                  { attrs: { id: "clip0_2095_106" } },
                                  [
                                    _c("rect", {
                                      attrs: {
                                        width: "18",
                                        height: "18",
                                        fill: "white",
                                      },
                                    }),
                                  ]
                                ),
                              ]),
                            ]
                          ),
                          _vm._v(" "),
                          _c("span", { staticClass: "d-none d-lg-block" }, [
                            _vm._v(_vm._s(_vm._f("trans")("Good"))),
                          ]),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "button",
                        {
                          staticClass: "btn-feedback",
                          class: {
                            disabled:
                              _vm.currentJob.feedback.loading === true ||
                              _vm.currentJob.feedback.submittedFull === true,
                            active: _vm.rating === 3,
                          },
                          on: {
                            click: function ($event) {
                              _vm.rating = 3
                            },
                          },
                        },
                        [
                          _c(
                            "svg",
                            {
                              attrs: {
                                xmlns: "http://www.w3.org/2000/svg",
                                width: "18",
                                height: "18",
                                viewBox: "0 0 18 18",
                                fill: "none",
                              },
                            },
                            [
                              _c(
                                "g",
                                {
                                  attrs: {
                                    "clip-path": "url(#clip0_2095_115)",
                                  },
                                },
                                [
                                  _c("path", {
                                    attrs: {
                                      d: "M18 9C18 13.9705 13.9705 18 9 18C4.03 18 0 13.9705 0 9C0 4.03 4.03 0 9 0C13.9705 0 18 4.03 18 9Z",
                                      fill: "#FFCC4D",
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c("path", {
                                    attrs: {
                                      d: "M5.75 10C6.44036 10 7 9.2165 7 8.25C7 7.2835 6.44036 6.5 5.75 6.5C5.05964 6.5 4.5 7.2835 4.5 8.25C4.5 9.2165 5.05964 10 5.75 10Z",
                                      fill: "#664500",
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c("path", {
                                    attrs: {
                                      d: "M12.25 10C12.9404 10 13.5 9.2165 13.5 8.25C13.5 7.2835 12.9404 6.5 12.25 6.5C11.5596 6.5 11 7.2835 11 8.25C11 9.2165 11.5596 10 12.25 10Z",
                                      fill: "#664500",
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c("path", {
                                    attrs: {
                                      d: "M6 14C7 11.5 12.5 11.5 12.5 12.5C12.5 13 8.5 12 6 14Z",
                                      fill: "#664500",
                                    },
                                  }),
                                ]
                              ),
                              _vm._v(" "),
                              _c("defs", [
                                _c(
                                  "clipPath",
                                  { attrs: { id: "clip0_2095_115" } },
                                  [
                                    _c("rect", {
                                      attrs: {
                                        width: "18",
                                        height: "18",
                                        fill: "white",
                                      },
                                    }),
                                  ]
                                ),
                              ]),
                            ]
                          ),
                          _vm._v(" "),
                          _c("span", { staticClass: "d-none d-lg-block" }, [
                            _vm._v(_vm._s(_vm._f("trans")("Medium"))),
                          ]),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "button",
                        {
                          staticClass: "btn-feedback",
                          class: {
                            disabled:
                              _vm.currentJob.feedback.loading === true ||
                              _vm.currentJob.feedback.submittedFull === true,
                            active: _vm.rating === 2,
                          },
                          on: {
                            click: function ($event) {
                              _vm.rating = 2
                            },
                          },
                        },
                        [
                          _c(
                            "svg",
                            {
                              attrs: {
                                xmlns: "http://www.w3.org/2000/svg",
                                width: "18",
                                height: "18",
                                viewBox: "0 0 18 18",
                                fill: "none",
                              },
                            },
                            [
                              _c(
                                "g",
                                {
                                  attrs: {
                                    "clip-path": "url(#clip0_2095_123)",
                                  },
                                },
                                [
                                  _c("path", {
                                    attrs: {
                                      d: "M18 9C18 13.9705 13.9705 18 9 18C4.03 18 0 13.9705 0 9C0 4.03 4.03 0 9 0C13.9705 0 18 4.03 18 9Z",
                                      fill: "#FFCC4D",
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c("path", {
                                    attrs: {
                                      d: "M5.75 9C6.44036 9 7 8.2165 7 7.25C7 6.2835 6.44036 5.5 5.75 5.5C5.05964 5.5 4.5 6.2835 4.5 7.25C4.5 8.2165 5.05964 9 5.75 9Z",
                                      fill: "#664500",
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c("path", {
                                    attrs: {
                                      d: "M12.25 9C12.9404 9 13.5 8.2165 13.5 7.25C13.5 6.2835 12.9404 5.5 12.25 5.5C11.5596 5.5 11 6.2835 11 7.25C11 8.2165 11.5596 9 12.25 9Z",
                                      fill: "#664500",
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c("path", {
                                    attrs: {
                                      d: "M4.3325 13.9355C4.37553 13.9744 4.43073 13.9971 4.48865 13.9997C4.54657 14.0023 4.60361 13.9848 4.65 13.95C4.6695 13.9355 6.611 12.5 9 12.5C11.383 12.5 13.331 13.9355 13.35 13.95C13.3964 13.9848 13.4534 14.0024 13.5113 13.9998C13.5692 13.9972 13.6244 13.9746 13.6675 13.9358C13.7105 13.897 13.7388 13.8444 13.7473 13.7871C13.7559 13.7297 13.7443 13.6712 13.7145 13.6215C13.65 13.5145 12.106 11 9 11C5.894 11 4.3495 13.514 4.2855 13.6215C4.25576 13.6712 4.24418 13.7297 4.25275 13.7869C4.26133 13.8442 4.28951 13.8967 4.3325 13.9355Z",
                                      fill: "#664500",
                                    },
                                  }),
                                ]
                              ),
                              _vm._v(" "),
                              _c("defs", [
                                _c(
                                  "clipPath",
                                  { attrs: { id: "clip0_2095_123" } },
                                  [
                                    _c("rect", {
                                      attrs: {
                                        width: "18",
                                        height: "18",
                                        fill: "white",
                                      },
                                    }),
                                  ]
                                ),
                              ]),
                            ]
                          ),
                          _vm._v(" "),
                          _c("span", { staticClass: "d-none d-lg-block" }, [
                            _vm._v(_vm._s(_vm._f("trans")("Bad"))),
                          ]),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "button",
                        {
                          staticClass: "btn-feedback",
                          class: {
                            disabled:
                              _vm.currentJob.feedback.loading === true ||
                              _vm.currentJob.feedback.submittedFull === true,
                            active: _vm.rating === 1,
                          },
                          on: {
                            click: function ($event) {
                              _vm.rating = 1
                            },
                          },
                        },
                        [
                          _c(
                            "svg",
                            {
                              attrs: {
                                xmlns: "http://www.w3.org/2000/svg",
                                width: "18",
                                height: "18",
                                viewBox: "0 0 18 18",
                                fill: "none",
                              },
                            },
                            [
                              _c(
                                "g",
                                {
                                  attrs: {
                                    "clip-path": "url(#clip0_2097_131)",
                                  },
                                },
                                [
                                  _c("path", {
                                    attrs: {
                                      d: "M18 9C18 13.9705 13.9705 18 9 18C4.03 18 0 13.9705 0 9C0 4.03 4.03 0 9 0C13.9705 0 18 4.03 18 9Z",
                                      fill: "#FFCC4D",
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c("path", {
                                    attrs: {
                                      d: "M12.7425 14.9395C12.72 14.85 12.1585 12.75 8.99999 12.75C5.84149 12.75 5.27999 14.85 5.25749 14.9395C5.24444 14.9923 5.24894 15.0479 5.27033 15.0979C5.29171 15.1478 5.32881 15.1895 5.37599 15.2165C5.42356 15.2429 5.47834 15.2535 5.53232 15.2465C5.58629 15.2396 5.63664 15.2156 5.67599 15.178C5.68549 15.1685 6.65299 14.25 8.99999 14.25C11.347 14.25 12.315 15.1685 12.324 15.1775C12.3626 15.2159 12.4127 15.2406 12.4667 15.2479C12.5207 15.2553 12.5755 15.2447 12.623 15.218C12.6707 15.1911 12.7082 15.1492 12.7298 15.0989C12.7513 15.0486 12.7558 14.9926 12.7425 14.9395ZM7.85349 8.6465C6.22599 7.019 3.61049 7 3.49999 7C3.37125 7.00569 3.24966 7.06083 3.16055 7.15392C3.07144 7.24701 3.02167 7.37089 3.02161 7.49976C3.02154 7.62863 3.07119 7.75256 3.16021 7.84574C3.24922 7.93892 3.37075 7.99418 3.49949 8C3.51399 8 4.46199 8.011 5.49099 8.3685C5.19449 8.6885 4.99999 9.1855 4.99999 9.75C4.99999 10.717 5.55949 11.5 6.24999 11.5C6.94049 11.5 7.49999 10.717 7.49999 9.75C7.49999 9.663 7.49049 9.58 7.48149 9.4965C7.48799 9.4965 7.49399 9.5 7.49999 9.5C7.59897 9.50022 7.69579 9.47102 7.77815 9.41612C7.86051 9.36122 7.9247 9.28309 7.96258 9.19164C8.00045 9.10019 8.01031 8.99955 7.99088 8.90249C7.97146 8.80543 7.92364 8.71633 7.85349 8.6465ZM14.5 7C14.3895 7 11.7745 7.019 10.1465 8.6465C10.0763 8.71633 10.0285 8.80543 10.0091 8.90249C9.98968 8.99955 9.99953 9.10019 10.0374 9.19164C10.0753 9.28309 10.1395 9.36122 10.2218 9.41612C10.3042 9.47102 10.401 9.50022 10.5 9.5C10.5065 9.5 10.512 9.4965 10.518 9.4965C10.51 9.58 10.5 9.663 10.5 9.75C10.5 10.717 11.0595 11.5 11.75 11.5C12.4405 11.5 13 10.717 13 9.75C13 9.1855 12.8055 8.6885 12.509 8.3685C13.1516 8.14973 13.8226 8.02559 14.501 8C14.5667 7.99993 14.6317 7.98694 14.6923 7.96175C14.7529 7.93656 14.808 7.89968 14.8544 7.8532C14.9008 7.80672 14.9376 7.75157 14.9626 7.69088C14.9877 7.63019 15.0006 7.56516 15.0005 7.4995C15.0004 7.43384 14.9874 7.36883 14.9622 7.3082C14.9371 7.24756 14.9002 7.19248 14.8537 7.14609C14.8072 7.09971 14.7521 7.06294 14.6914 7.03787C14.6307 7.0128 14.5657 6.99993 14.5 7Z",
                                      fill: "#664500",
                                    },
                                  }),
                                ]
                              ),
                              _vm._v(" "),
                              _c("defs", [
                                _c(
                                  "clipPath",
                                  { attrs: { id: "clip0_2097_131" } },
                                  [
                                    _c("rect", {
                                      attrs: {
                                        width: "18",
                                        height: "18",
                                        fill: "white",
                                      },
                                    }),
                                  ]
                                ),
                              ]),
                            ]
                          ),
                          _vm._v(" "),
                          _c("span", { staticClass: "d-none d-lg-block" }, [
                            _vm._v(_vm._s(_vm._f("trans")("Worse"))),
                          ]),
                        ]
                      ),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("TextArea", {
                    staticClass: "w-100 feedback-text-area",
                    class: {
                      disabled:
                        _vm.currentJob.feedback.loading === true ||
                        _vm.currentJob.feedback.submittedFull === true,
                    },
                    attrs: {
                      "border-class": "br-4",
                      label: _vm.placeholder,
                      "max-characters": 4000,
                      rows: "4",
                      value: _vm.message,
                      aiCustom: true,
                      disabled:
                        _vm.currentJob.feedback.loading === true ||
                        _vm.currentJob.feedback.submittedFull === true,
                      name: "prompt",
                      id: "feedback-form-textarea",
                      type: "text",
                    },
                    model: {
                      value: _vm.message,
                      callback: function ($$v) {
                        _vm.message = $$v
                      },
                      expression: "message",
                    },
                  }),
                ],
                1
              )
            : _c("div", [
                !_vm.doNotShowTrustPage
                  ? _c(
                      "div",
                      {
                        staticClass:
                          "alert alert-info feedback-info d-flex gap-20 m-0 p-20",
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "icon-box d-none d-lg-flex" },
                          [
                            _c(
                              "svg",
                              {
                                attrs: {
                                  xmlns: "http://www.w3.org/2000/svg",
                                  width: "42",
                                  height: "42",
                                  viewBox: "0 0 42 42",
                                  fill: "none",
                                },
                              },
                              [
                                _c("path", {
                                  attrs: {
                                    d: "M21 0.5C9.6963 0.5 0.5 9.6963 0.5 21C0.5 32.3037 9.6963 41.5 21 41.5C32.3037 41.5 41.5 32.3037 41.5 21C41.5 9.6963 32.3037 0.5 21 0.5ZM9.59175 13.7573C10.1429 13.1905 10.8925 12.8594 11.6827 12.8338C12.473 12.8082 13.2424 13.09 13.8291 13.62C14.4068 13.0822 15.1702 12.7888 15.9593 12.8014C16.7485 12.814 17.5022 13.1316 18.0624 13.6876C19.2862 14.9012 19.3006 16.8057 18.0992 18.0295L13.8967 22.2997L9.62865 18.0972C9.33807 17.8165 9.10631 17.4807 8.9469 17.1095C8.78749 16.7383 8.70362 16.339 8.70018 15.935C8.69675 15.531 8.77382 15.1304 8.92689 14.7565C9.07997 14.3826 9.30599 14.0429 9.59175 13.7573ZM21 33.3C12.8 33.3 10.75 25.1 10.75 25.1H31.25C31.25 25.1 29.2 33.3 21 33.3ZM32.4492 18.0295L28.2467 22.2997L23.9786 18.0972C23.6882 17.8165 23.4565 17.4808 23.2971 17.1097C23.1376 16.7385 23.0537 16.3394 23.05 15.9354C23.0464 15.5315 23.1232 15.1309 23.2759 14.757C23.4287 14.383 23.6543 14.0432 23.9397 13.7573C24.491 13.1899 25.2409 12.8585 26.0317 12.8328C26.8224 12.8072 27.5922 13.0894 28.1791 13.62C28.7568 13.0822 29.5202 12.7888 30.3093 12.8014C31.0985 12.814 31.8522 13.1316 32.4123 13.6876C33.6362 14.8992 33.6526 16.8057 32.4492 18.0295Z",
                                    fill: "#FBFBFB",
                                  },
                                }),
                              ]
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "d-flex flex-column gap-10" },
                          [
                            _c("strong", { staticClass: "font-size-125" }, [
                              _vm._v(
                                _vm._s(
                                  _vm._f("trans")(
                                    "You are awesome, thank you for your rating!"
                                  )
                                )
                              ),
                            ]),
                            _vm._v(" "),
                            _c("p", {
                              domProps: {
                                innerHTML: _vm._s(_vm.reputationRatingText),
                              },
                            }),
                            _vm._v(" "),
                            _c(
                              "a",
                              {
                                staticClass: "text-decoration-none",
                                attrs: {
                                  href: _vm.trustPage?.url,
                                  target: "_blank",
                                  rel: "noreferrer",
                                },
                                on: { click: _vm.clickTrustPageLink },
                              },
                              [
                                _c("strong", { staticClass: "text-info" }, [
                                  _vm._v(_vm._s(_vm.trustPage?.url)),
                                ]),
                              ]
                            ),
                          ]
                        ),
                      ]
                    )
                  : _vm._e(),
              ]),
          _vm._v(" "),
          _vm.selectRatingError
            ? _c("div", { staticClass: "alert alert-warning" }, [
                _vm._v(
                  "\n          " +
                    _vm._s(
                      _vm._f("trans")(
                        "Please enter a rating before submitting your feedback!"
                      )
                    ) +
                    "\n        "
                ),
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.currentJob.feedback.loading === true
            ? _c("div", { staticClass: "alert alert-info" }, [
                _vm._v(
                  "\n          " +
                    _vm._s(_vm._f("trans")("Submitting your feedback..")) +
                    "\n        "
                ),
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.doNotShowTrustPage
            ? _c("div", { staticClass: "alert alert-info" }, [
                _vm._v(
                  "\n          " +
                    _vm._s(
                      _vm._f("trans")("Thank you for giving us your feedback.")
                    ) +
                    "\n        "
                ),
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.currentJob.feedback.submittedFull !== true
            ? _c("div", [
                _c(
                  "button",
                  {
                    staticClass: "btn",
                    class: {
                      disabled: _vm.currentJob.feedback.loading === true,
                      "d-none": _vm.currentJob.feedback.submittedFull === true,
                    },
                    attrs: { id: "feedback-submit-btn-main" },
                    on: {
                      click: function ($event) {
                        $event.preventDefault()
                        return _vm.send.apply(null, arguments)
                      },
                    },
                  },
                  [
                    _c("strong", [
                      _vm._v(" " + _vm._s(_vm._f("trans")("Submit"))),
                    ]),
                    _vm._v(" "),
                    _vm.currentJob.feedback.loading
                      ? _c("i", {
                          staticClass: "fa fa-spin btn-loading-animation",
                        })
                      : _vm._e(),
                  ]
                ),
              ])
            : _vm._e(),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }